const tryggHansaDocumentBaseUrl = 'https://getapet.com/documents/trygg-hansa';

export const insuranceDocumentUrls = {
  cancellationRight: `${tryggHansaDocumentBaseUrl}/angerratt.pdf`,
  customerInformation: `${tryggHansaDocumentBaseUrl}/kundinformation.pdf`,
  litterInsurancePreAndPostPurchaseInformation: `${tryggHansaDocumentBaseUrl}/for-och-efterkopsinformation.pdf`,
  litterInsuranceProductFacts: `${tryggHansaDocumentBaseUrl}/produktfakta.pdf`,
  litterInsuranceTerms: `${tryggHansaDocumentBaseUrl}/kullforsakring-villkor.pdf`,
} as const;
